import { createAsyncThunk } from '@reduxjs/toolkit';
import qs from 'qs';

import instance from 'configs/requests';

export const getChatAuth = createAsyncThunk(
  'chat/getAuth',
  async ({ displayName }: { displayName: string }) => {
    const { data } = await instance.get(
      `/clinician-gateway/chat/auth?${qs.stringify({ displayName })}`
    );
    return data as IChatAuth;
  }
);
